export const LineaEstrategicaOptions = [
  { key: "agendaCultural", value: "Agenda cultural", text: "Agenda cultural" },
  { key: "apoyoConcertado", value: "Apoyos concertados", text: "Apoyos concertados" },
  { key: "audiciones", value: "Audiciones", text: "Audiciones" },
  { key: "basncoJurados", value: "Banco de jurados", text: "Banco de jurados" },
  {
    key: "circuloNacional",
    value: "Circulación nacional e internacional",
    text: "Circulación nacional e internacional",
  },
  { key: "economiasCreativas", value: "Economías creativas", text: "Economías creativas" },
  { key: "estimulos", value: "Estímulos", text: "Estímulos" },
  { key: "leyEspectaculos", value: "Ley de espectáculos públicos", text: "Ley de espectáculos públicos" },
  { key: "premios", value: "Premios", text: "Premios" },
  { key: "salaAbierta", value: "Salas abierta", text: "Salas abierta" },
  { key: "eventosCiudad", value: "Eventos de ciudad", text: "Eventos de ciudad" },
];

export const tipoConvocatoria = [
  { key: 1, value: 1, text: "Convocatoria" },
  { key: 2, value: 2, text: "Jurados" },
  { key: 3, value: 3, text: "BEPS" },
];

export const tipoEntidad = [
  { key: 1, value: 'SCC', text: "Secretaría de Cultura Ciudadana" },
  { key: 2, value: 'PDL y PPC', text: "Programa Planeación del Desarrollo Local y Presupuesto Participativo de Cultura 2023" },
  { key: 3, value: 'SM', text: "Secretaría de Mujeres" },
  { key: 4, value: 'SDE', text: "Secretaría de Desarrollo Económico" },
  { key: 5, value: 'MCM', text: "Museo Casa de la Memoria" },
  { key: 6, value: 'OE', text: "Otras Entidades" },
];

export const CicloOptions = [
  { key: "circulacion", value: "Circulación", text: "Circulación" },
  { key: "creacion", value: "Creación", text: "Creación" },
  { key: "formacion", value: "Formación", text: "Formación" },
  { key: "investigacion", value: "Investigación", text: "Investigación" },
  { key: "jurados", value: "Jurados", text: "Jurados" },
  { key: "produccion", value: "Producción", text: "Producción" },
];

export const CoberturaBepsOptions = [
  { key: "areaMetropolitana", value: "Área metropolitana", text: "Área metropolitana" },
  { key: "municipal", value: "Municipal", text: "Municipal" },
  { key: "nacional", value: "Nacional", text: "Nacional" },
];

export const CoberturaOptions = [
  { key: "areaMetropolitana", value: "Área metropolitana", text: "Área metropolitana" },
  { key: "municipal", value: "Municipal", text: "Municipal" },
  { key: "nacional", value: "Nacional", text: "Nacional" },
  { key: "internacional", value: "Internacional", text: "Internacional" },
];

export const ModalidadEstimuloOptions = [
  { key: "apoyo", value: "Apoyo", text: "Apoyo" },
  { key: "pasantia", value: "Pasantía", text: "Pasantía" },
  { key: "premio", value: "Premio", text: "Premio" },
  { key: "estimulo", value: "Estimulo", text: "Estimulo" },
  { key: "residenciasalas", value: "Residencia - Salas", text: "Residencia - Salas" },
];

export const TipoEstimuloOptions = [
  { key: "economico", value: "Económico", text: "Económico" },
  { key: "noAplica", value: "No Aplica", text: "No Aplica" },
];

export const EntidadOptions = [
  { key: 1, value: 'SCC', text: "Secretaría de Cultura Ciudadana" },
  { key: 2, value: 'PDL y PPC', text: "Programa Planeación del Desarrollo Local y Presupuesto Participativo de Cultura 2023" },
  { key: 3, value: 'SM', text: "Secretaría de Mujeres" },
  { key: 4, value: 'SDE', text: "Secretaría de Desarrollo Económico" },
  { key: 5, value: 'MCM', text: "Museo Casa de la Memoria" },
  { key: 6, value: 'OE', text: "Otras Entidades" },
];

export const EntidadSelected = ["SCC"];

export const AreaOptions = [
  { key: "adquisicionEquipos", value: "Adquisición de equipos", text: "Adquisición de equipos" },
  { key: "apoyoParticipacion", value: "Apoyo para la participación", text: "Apoyo para la participación" },
  { key: "areaIntegradas", value: "Áreas integradas", text: "Áreas integradas" },
  { key: "arte", value: "Arte", text: "Arte" },
  { key: "arteVisuales", value: "Artes visuales", text: "Artes visuales" },
  { key: "audiovisuales", value: "Audiovisuales", text: "Audiovisuales" },
  { key: "circo", value: "Circo", text: "Circo" },
  { key: "colaborativos", value: "Colaborativos", text: "Colaborativos" },
  { key: "destinoSeguro", value: "Destino seguro", text: "Destino seguro" },
  {
    key: "formacionAsistenciaTecnica",
    value: "Formación y asistencia técnica",
    text: "Formación y asistencia técnica",
  },
  { key: "gestionCultural", value: "Gestión cultural", text: "Gestión cultural" },
  { key: "lecturaBibliotecas", value: "Lectura y bibliotecas", text: "Lectura y bibliotecas" },
  { key: "literatura", value: "Literatura", text: "Literatura" },
  { key: "musica", value: "Música", text: "Música" },
  { key: "patrimonio", value: "Patrimonio", text: "Patrimonio" },
  { key: "produccionProductos", value: "Producción de productos", text: "Producción de productos" },
  { key: "RecreacionDeporte", value: "Recreación/deporte", text: "Recreacion/deporte" },
  { key: "TeatroActividades", value: "Teatro y actividades asociadas", text: "Teatro y actividades asociadas" },
  { key: "tecnologia", value: "Tecnología", text: "Tecnología" },
  { key: "unidosSector", value: "Unidos por el sector", text: "Unidos por el sector" },
  { key: "danza", value: "Danza", text: "Danza" },
  { key: "artesanias", value: "Artesanias", text: "Artesanias" },
  { key: "comunicaciones", value: "Comunicaciones", text: "Comunicaciones" },
  { key: "variasAreas", value: "Varias áreas", text: "Varias áreas" },
];

export const NumeroConvocatoiriaOptions = [
  { key: "1", value: "1", text: "Primera" },
  { key: "2", value: "2", text: "Segunda" },
  { key: "3", value: "3", text: "Tercera" },
  { key: "4", value: "4", text: "Cuarta" },
];

export const QuienParticipaOptions = [
  { key: 1, value: 1, text: "Persona natural" },
  { key: 2, value: 2, text: "Persona jurídica" },
  { key: 3, value: 3, text: "Grupo conformado" },
];

export const paisesOptions = [{ key: 1, value: 1, text: "Colombia" }];

export const departamentosOptions = [
  { key: 1, value: "Amazonas", text: "Amazonas" },
  { key: 2, value: "Antioquia", text: "Antioquia" },
  { key: 3, value: "Arauca", text: "Arauca" },
  { key: 4, value: "Atlántico", text: "Atlántico" },
  { key: 5, value: "Bolivar", text: "Bolivar" },
];

export const municipiosOptions = [
  { key: 1, value: "Cáceres", text: "Cáceres" },
  { key: 2, value: "Caucasia", text: "Caucasia" },
  { key: 3, value: "El Bagre", text: "El Bagre" },
  { key: 4, value: "Nechí", text: "Nechí" },
  { key: 5, value: "Tarazá", text: "Tarazá" },
];

export const OpcionesPersonaNatural = [
  { key: 1, value: 1, text: "Gestor" },
  { key: 2, value: 2, text: "Creador" },
];

export const comunasOptions = [
  { key: "1", value: "Popular", text: "Popular" },
  { key: "2", value: "Santa Cruz", text: "Santa Cruz" },
  { key: "3", value: "Manrique", text: "Manrique" },
  { key: "4", value: "Aranjuez", text: "Aranjuez" },
  { key: "5", value: "Castilla", text: "Castilla" },
  { key: "6", value: "Doce de Octubre", text: "Doce de Octubre" },
  { key: "7", value: "Robledo", text: "Robledo" },
  { key: "8", value: "Villa Hermosa", text: "Villa Hermosa" },
  { key: "9", value: "Buenos Aires", text: "Buenos Aires" },
  { key: "10", value: "La Candelaria", text: "La Candelaria" },
  { key: "11", value: "Laureles Estadio", text: "Laureles Estadio" },
  { key: "12", value: "La América", text: "La América" },
  { key: "13", value: "San Javier", text: "San Javier" },
  { key: "14", value: "El Poblado", text: "El Poblado" },
  { key: "15", value: "Guayabal", text: "Guayabal" },
  { key: "16", value: "Belén", text: "Belén" },
  { key: "50", value: "San Sebastián de Palmitas", text: "San Sebastián de Palmitas" },
  { key: "60", value: "San Cristóbal", text: "San Cristóbal" },
  { key: "70", value: "Altavista", text: "Altavista" },
  { key: "80", value: "San Antonio de Prado", text: "San Antonio de Prado" },
  { key: "90", value: "Santa Elena", text: "Santa Elena" }
];

export const tipoviaOptions = [
  { key: 1, value: "Autopista", text: "Autopista" },
  { key: 2, value: "Autovía", text: "Autovía" },
  { key: 3, value: "Avenida", text: "Avenida" },
  { key: 4, value: "Bulevar", text: "Bulevar" },
  { key: 5, value: "Calle", text: "Calle" },
  { key: 6, value: "Carrera", text: "Carrera" },
  { key: 7, value: "Callejón", text: "Callejón" },
  { key: 8, value: "Camino", text: "Camino" },
  { key: 9, value: "Circular", text: "Circular" },
  { key: 10, value: "Diagonal", text: "Diagonal" },
  { key: 12, value: "Carril", text: "Carril" },
  { key: 12, value: "Carretera", text: "Carretera" },
  { key: 13, value: "Sendero", text: "Sendero" },
  { key: 14, value: "Vía rápida", text: "Vía rápida" },
  { key: 15, value: "Urbanización", text: "Urbanización" },
  { key: 16, value: "Transversal", text: "Transversal" },
];

export const zonaOptions = [
  { key: 1, value: "Norte", text: "Norte" },
  { key: 2, value: "Sur", text: "Sur" },
  { key: 3, value: "Este", text: "Este" },
  { key: 4, value: "Oeste", text: "Oeste" },
];

export const barriosOptions = [
  { key: 1, value: 1, text: "El poblado" },
  { key: 2, value: 2, text: "Prado" },
  { key: 3, value: 3, text: "Laureles" },
  { key: 4, value: 4, text: "Belén" },
  { key: 5, value: 5, text: "San Joaquín" },
];

export const RequisitosOptions = [
  { key: 1, value: "Anexo", text: "Anexo" },
  { key: 2, value: "Hoja de vida", text: "Hoja de vida" },
  { key: 3, value: "Presupuesto", text: "Presupuesto" },
  { key: 4, value: "Propuesta", text: "Propuesta" },
];

export const Requisitos2Options = [
  { key: 1, value: "Anexo", text: "Anexo" },
  { key: 2, value: "Formato", text: "Formato" },
  { key: 3, value: "Resolución", text: "Resolución" },
  { key: 4, value: "Informes", text: "Informes" },
];

export const TipoDocumentosOptions = [
  { key: 1, value: "CC", text: "Cedula de ciudadanía" },
  { key: 2, value: "CE", text: "Cedula extranjera" },
  { key: 3, value: "CV", text: "Certificado de vinculación al país" },
  { key: 4, value: "PA", text: "Pasaporte" },
  { key: 5, value: "RC", text: "Registro civil" },
  { key: 6, value: "TI", text: "Tarjeta de identidad" },
  { key: 7, value: "NT", text: "NIT" },
  { key: 8, value: "PT", text: "Permiso Temporal de Permanencia" }
];

export const TipoIdentificacionUMEOptions = [
  { key: 1, value: "1-Cédula de Ciudadanía", text: "Cédula de ciudadanía" },
  { key: 2, value: "2-Tarjeta de identidad", text: "Tarjeta de identidad" },
  { key: 3, value: "3-Cédula de Extranjería", text: "Cédula de Extranjería" },
  { key: 4, value: "4-NIT", text: "NIT" },
  { key: 5, value: "5-PTP", text: "Permiso Temporal de Permanencia" }
];

export const consolidateIdentificate = [
  { key: 1, value: "1-Cédula de Ciudadanía", target: "CC" },
  { key: 2, value: "2-Tarjeta de identidad", target: "TI" },
  { key: 3, value: "3-Cédula de Extranjería", target: "CE" },
  { key: 4, value: "4-NIT", target: "NT" },
  { key: 5, value: "5-PTP", target: "PT" }
]

export const SexoOptions = [
  { key: 1, value: "M", text: "Masculino" },
  { key: 2, value: "F", text: "Femenino" },
  { key: 3, value: "ITX", text: "Intersexual" },
  { key: 3, value: "IND", text: "Indefinido" },
];

export const SexoUmeOptions = [
  { key: 1, value: "m", text: "Masculino" },
  { key: 2, value: "f", text: "Femenino" },
  { key: 3, value: "o", text: "Otro" },
];

export const EtniaOptions = [
  { key: 1, value: "Palenqueros", text: "Palenqueros" },
  { key: 2, value: "Comunidades Negras o Afrocolombianas", text: "Comunidades negras o afrocolombianas" },
  { key: 3, value: "Comunidad raizal", text: "Comunidad raizal" },
  { key: 4, value: "Pueblos y Comunidades Indígenas", text: "Pueblos y comunidades indígenas" },
  { key: 5, value: "Pueblo Rom o Gitano", text: "Pueblo Rom o Gitano" },
  { key: 6, value: "Ninguno", text: "Ninguno" },
];

export const IdentidadGeneroOptions = [
  { key: 12, value: "DSC_01", text: "Discapacidad auditiva" },
  { key: 13, value: "DSC_02", text: "Discapacidad visual" },
  { key: 14, value: "DSC_03", text: "Discapacidad física" },
  { key: 15, value: "DSC_04", text: "Discapacidad intelectual (cognitiva)" },
  { key: 16, value: "DSC_05", text: "Discapacidad Psicosocial (mental)" },
  { key: 17, value: "DSC_06", text: "Discapacidad múltiple" },
  { key: 18, value: "DSC_07", text: "Sordoceguera" },
  { key: 19, value: "DSC_08", text: "Ninguna" },
];

export const IdentidadGeneroUMEOptions = [
  { key: 1, value: "m", text: "Hombre" },
  { key: 2, value: "f", text: "Mujer" },
  { key: 3, value: "o", text: "Otro" }
];


export const OrientacionSexualoOptions = [
  { key: 1, value: "OSX_01", text: "Heterosexual" },
  { key: 2, value: "OSX_02", text: "Lesbiana" },
  { key: 3, value: "OSX_03", text: "Bisexual" },
  { key: 4, value: "OSX_04", text: "Gay" },
  { key: 5, value: "OSX_05", text: "Asexual" },
  { key: 6, value: "OSX_06", text: "Pansexual" },
  { key: 7, value: "OSX_98", text: "Sin Dato" },
  { key: 8, value: "OSX_99", text: "No sabes no respondes" },
];

export const EstratoOptions = [
  { key: 1, value: "1", text: "Uno" },
  { key: 2, value: "2", text: "Dos" },
  { key: 3, value: "3", text: "Tres" },
  { key: 4, value: "4", text: "Cuatro" },
  { key: 5, value: "5", text: "Cinco" },
  { key: 6, value: "6", text: "Seis" },
];

export const TiposIdentificacion = [
  { key: 3, value: 3, text: "Grupo Conformado" },
  { key: 2, value: 2, text: "Persona juridica" },
  { key: 1, value: 1, text: "Persona natural" },
];

export const cantidadRegistros = [
  { key: 1, value: 10, text: "10" },
  { key: 2, value: 20, text: "20" },
  { key: 3, value: 50, text: "50" },
  { key: 4, value: 100, text: "100" },
];

export const Years = [
  { key: 1, value: 2021, text: "2021" },
  { key: 2, value: 2020, text: "2020" },
  { key: 3, value: 2019, text: "2019" },
  { key: 4, value: 2018, text: "2018" },
  { key: 5, value: 2017, text: "2017" },
  { key: 6, value: 2016, text: "2016" },
];

export const EstadosOptions = [
  { key: "Abierta", value: "Abierta", text: "Abierta" },
  { key: "En proceso", value: "En proceso", text: "En proceso" },
  { key: "Cerrada", value: "Cerrada", text: "Cerrada" },
];

export const EstadosPostulacion = [
  // { key: "Asignados", value: "Asignado", text: "Asignados" },
  // { key: "Sin asignar", value: "Sin asignar", text: "Sin Asignar" },
  { key: 1, value: "Sin revisar", text: "Sin revisar" },
  { key: 2, value: "Aceptado", text: "Aceptado" },
  { key: 3, value: "No aceptado", text: "No aceptado" },
  { key: 4, value: "Subsanar", text: "Subsanar" },
  { key: 5, value: "Subsanado", text: "Subsanado" },
  { key: 6, value: "Inscrito sin revisar", text: "Inscrito sin revisar" },
];
